/*
 * @Author: Teemo Ding
 * @Date: 2021-06-25 17:07:18
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-30 16:20:00
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelInvoice/Components/ImageUpload/index.tsx
 */
import React from 'react';
import _ from 'lodash';
import { Uploader } from '@/src/components';
import { useSingleImageEffect } from '@/src/components/Upload';
import css from '../../css.module.less';

interface IProps {
  value?: any;
  onChange?: any;
  disabled?: boolean;
}

const ImageUpload = ({ value, onChange, disabled }: IProps) => {
  const [fileList, setFileList] = React.useState(value ? [value] : []);
  useSingleImageEffect(value, fileList, setFileList);

  return (
    <div className={css.upload}>
      <Uploader
        height={180}
        multiple={false}
        hideRemove={disabled}
        hideReplace={disabled}
        hideEdit={disabled}
        fileList={fileList}
        onChange={(imgArr = []) => {
          setFileList(imgArr);
          // if (onChange) {
          const _l = _.last(imgArr);
          onChange(_l);
          // }
        }}></Uploader>
    </div>
  );
};
export default ImageUpload;
